<template>
  <div>
    <div class="container" id="take">
      <h2 class="text-center header-font">Program Structure</h2>
      <p class="first-p">
        Data science bootcamp consists of approximately
        <span style="font-weight:700; ">38 hours </span> of material delivered
        over a period of
        <span style="font-weight:700; ">1.5 months/ 6 weeks.</span> To
        participate in this Bootcamp, you are required to pass an assessment
        test with minimum <span style="font-weight:700; ">60%</span> of the
        total score.
        <br />
        <br />
        The bootcamp will only have
        <span style="font-weight:700; ">20 seats.</span> It’s on a first come
        first served basis. Take the quiz today to secure your spot.
      </p>
      <div class="grid">
        <div class="text">
          <h4>Length</h4>
          <h3>
            1.5 Month/ <br />
            6 Weeks
          </h3>
        </div>
        <div class="text">
          <h4>Bootcamp Starts</h4>
          <h3>25th Oct, <br />2021</h3>
        </div>
        <div class="text">
          <h4>Cost</h4>
          <h3>BDT <br />10,000**</h3>
        </div>
        <div class="text">
          <h4>Quiz Deadline</h4>
          <h3>
            18th Oct, <br />

            2021
          </h3>
        </div>
        <div class="text">
          <h4>Course Outline</h4>
          <a
            href="https://upskill-videos.s3.ap-southeast-1.amazonaws.com/Bootcamp+Outline.docx.pdf"
            download=""
            class="btn"
          >
            Download PDF
          </a>
        </div>
      </div>
      <div class="grid-2">
        <p style="text-align:left;color:white">
          ** If you take the quiz by 1st October 2021 and pass then you’ll avail
          a
          <span style="color:#FBBF05">20% discount</span> course fee.
          <br />
          <br />
          <span style="color:#FBBF05;text-align:left">
            If you are one of the top 5 students by the end of 6 weeks, you will
            get to interview at Intelligent Machines for a job. So, don’t miss
            the offer as the seats are limited!
          </span>
        </p>
        <a
          href="https://quiz.upskill.com.bd/assessment/cbad2e7d-8876-4ba8-8d50-72d273d39645?public=true"
        >
          <button class="btn-1" disabled>
            Take the Quiz
            (expired)
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.btn {
  background-color: transparent;
  border: 1px solid #2465f3;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
}

/* Darker background on mouse-over */
.btn:hover {
  background-color: transparent;
}
.btn-1 {
  background-color: white;
  min-width: 240px;
  min-height: 50px;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
}

/* Darker background on mouse-over */
.btn-1:hover {
  background-color: #f8f8ff;
}
.grid-2 {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  background-color: #184dbd;
  padding: 50px 150px;
}
.grid-2 p {
  padding-left: 25px;
  font: 700 1.125rem/1.5rem 'Manrope';
  color: #29292b;
  max-width: 600px !important;
}
.container p {
  text-align: center;
  max-width: 1020px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
}
.first-p {
  text-align: center;
  max-width: 970px;
  margin: 0 auto;
  font: 400 1.125rem/1.4rem 'Manrope';
  color: #626367;
  padding-bottom: 50px;
}
.text h4 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.text h3 {
  font: 700 2.25rem/2.75rem 'Manrope';
  color: #184dbd;
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.grid {
  padding: 50px;
  background-color: white;
  margin: 0 auto;
  max-width: 1300px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}
@media only screen and (max-width: 600px) {
  .grid {
    padding: 50px;
    background-color: white;
    margin: 0 auto;
    max-width: 350px;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px;
  }
  .grid-2 {
    display: flex;
    flex-direction: column;
    padding: 20px 15px;
  }
  .text h4 {
    font: 700 1.25rem/1.75rem 'Manrope';
    color: #29292b;
  }
  .text h3 {
    font: 700 1.75rem/2.5rem 'Manrope';
    color: #184dbd;
  }
  .grid-2 p {
    padding-left: 0;
    padding-bottom: 25px;
  }
  .grid-2 a {
    display: flex;
    justify-content: center;
  }
}
</style>
